import { Link } from "react-router-dom";

export const Wordmark = ({ testId = "nav-wordmark", onClick, className = "" }) => (
  <Link
    to="/"
    onClick={onClick}
    aria-label="ATA Forge home"
    data-testid={testId}
    className={`group inline-flex items-baseline gap-[0.28em] text-[17px] font-semibold tracking-[-0.02em] text-white ${className}`}
  >
    <span>ATA</span>
    <span className="font-medium text-white/60 transition-colors duration-300 group-hover:text-white">Forge</span>
  </Link>
);
